import { API } from '../api'

// Content API endpoints
export const API_CONTENT = `${API}/content`
export const API_RESORTS_NAMES = `${API}/resortsNames`

// Content types
export const KIND_KERNEL_HEADING = 'kernelHeading'
export const KIND_KERNEL_SUMMARY_BOX = 'kernelSummaryBox'
export const KIND_KERNEL_BOARD = 'kernelBoard'
export const KIND_KERNEL_ARTICLE = 'kernelArticle'
export const KIND_KERNEL_QUOTE_PANE = 'kernelQuotePane'
export const KIND_KERNEL_SECTION = 'kernelSection'
export const KIND_KERNEL_TOP_BOARD = 'kernelTopBoard'
export const KIND_KERNEL_CALENDAR_BOX = 'kernelCalendarBox'
export const KIND_KERNEL_SEARCH_WIDGET = 'kernelSearchWidget'
export const KIND_RESORT_DETAIL_ACCORDION = 'resortDetailAccordion'
export const KIND_DUES_LOANS = 'duesLoans'
export const KIND_CREDIT_SUMMARY = 'creditSummary'

// Scaffold content types
export const KIND_SCAFFOLD_APP_FOOTER = 'scaffoldAppFooter'
export const KIND_SCAFFOLD_SOCIAL_FOOTER = 'scaffoldSocialFooter'
export const KIND_SCAFFOLD_PAGE = 'scaffoldPage'
export const KIND_SCAFFOLD_ACCOUNT_MENU = 'scaffoldAccountMenu'
export const KIND_SCAFFOLD_TICKER = 'scaffoldTicker'
export const KIND_SCAFFOLD_LOADING = 'scaffoldLoading'

// Foundation content types
export const KIND_FOUNDATION_SIGN_IN = 'foundationSignIn'

// Search content types
export const KIND_SEARCH_CAL_AVAIL = 'searchAvailCal'

// Account content types
export const KIND_POINTS_BENEFITS = 'pointsBenefits'

// Slug constants
export const SLUG_WM_DUES_LOANS = 'wm-dues-loans'
export const SLUG_WM_POINTS_BENEFITS = 'wm-points-benefits'
